export enum CallQueueType {
    DIRECT_AGENT_GROUP = 'DirectAgentGroup',
    CALL_QUEUE = 'CallQueue',
    AGENT = 'Agent'
}